export enum RecurringEndType {
    OCCURRENCES = 'occurrences',
    END_DATE = 'end-date',
}
